import { IMapStyle } from '@/bundles/Map/interfaces';

export const defaultMapStyle: IMapStyle = {
  value: 'light',
  url: 'mapbox/light-v11?optimize=true',
  icon: 'mdi-map-outline',
  text: 'Light'
};
